import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute("/_authenticated/invoices")({
  component: InvoicesLayout,
});

// Layout pathful de invoices: da a la sección una ruta limpia "/invoices"
// (en vez de "/invoices/" sin layout) que coincide con el link del sidebar, y
// mantiene la sección montada al navegar entre sub-rutas (igual que quotations).
// Sin guard de permisos a propósito: cada sub-ruta tiene su propio permiso
// (invoices, invoices_payments, credit_notes, debit_notes, ...).
function InvoicesLayout() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "invoices", actions: ["read"] }]}
    >
      <Outlet />
    </RouteGuardPermissions>
  );
}
